/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_item = {
    readonly isSold: boolean | null;
    readonly isInProcurement?: boolean | null;
    readonly saveSearchData: {
        readonly name: string | null;
        readonly page: string | null;
    } | null;
    readonly skus?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly displayInfo: {
            readonly ctas: {
                readonly showPurchase: boolean | null;
                readonly showMakeOffer: boolean | null;
                readonly showRequestPrice: boolean | null;
                readonly showFollowCategory: boolean | null;
                readonly showAcceptOffer: boolean | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item" | "PdpSharedPurchaseButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedDeposit_item">;
    readonly " $refType": "PdpRespSidebarButtons_item";
};
export type PdpRespSidebarButtons_item$data = PdpRespSidebarButtons_item;
export type PdpRespSidebarButtons_item$key = {
    readonly " $data"?: PdpRespSidebarButtons_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "kind": "LinkedField",
      "name": "saveSearchData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "isInProcurement",
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDeposit_item"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "kind": "LinkedField",
          "name": "skus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                },
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "SkuDisplayInfo",
              "kind": "LinkedField",
              "name": "displayInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CTADisplay",
                  "kind": "LinkedField",
                  "name": "ctas",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showPurchase",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showMakeOffer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showRequestPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showFollowCategory",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showAcceptOffer",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '535c058fa0f75043bac41cfe301f41e6';
export default node;
